import { Injectable } from "@angular/core";
import { Observable, switchMap } from "rxjs";
import { localize } from "@webapp/localization/utils/localization.utils";
import { lazyState, loadModule } from "@webapp/okrs/okrs.future-states";
import { LazyModalService } from "@webapp/shared/modal/lazy-modal.service";
import { cancelButton, okButton } from "@webapp/ui/modal/utils/modal.utils";
import type { UpdateMetricComponent, UpdateMetricModalData } from "../components/update-metric/update-metric.component";

@Injectable({
  providedIn: "root",
})
export class UpdateMetricModalService {
  constructor(private readonly lazyModalService: LazyModalService) {}

  public openUpdateMetricModal(data?: UpdateMetricModalData): Observable<void> {
    const updateMetricModal$ = this.lazyModalService.create<UpdateMetricComponent>({
      lazyState,
      uiTitle: localize("update_key_result"),
      uiContentFn: () => loadModule().then((mod) => mod.UpdateMetricComponent),
      uiData: data,
      uiFooter: [
        okButton(localize("update"), {
          testId: "update-key-result-modal-update-button",
          disabled: (instance) => !!instance.indicators.saving || !!instance.indicators.loadingIndicator || !instance.isUpdateAllowed(),
          show: (instance) => instance.isActionAllowed("update"),
          onClick: (instance) => instance.save(),
        }),
        cancelButton(localize("cancel")),
      ],
      uiWidth: 657,
    });

    return updateMetricModal$.pipe(switchMap((modal) => modal.afterOpen));
  }
}
